import asset from '@/api/asset'

export default {
  getAssets ({ commit }, payload) {
    return asset.getAssets(payload)
      .then(response => {
        if (response && response.status === 200 && response.data.success === true) {
          const data = response.data
          return {
            ...data,
            asset: data.asset.map(
              (asset) => ({...asset, url_image: asset.url})
            )
          }
        }
      })
  },
  uploadAsset ({ commit }, payload) {
    return asset.uploadAsset(payload)
      .then(response => {
        if (response && response.status === 200) {
          const data = response
          return data
        }
      })
  }
}
